import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../createApiConfig';

export const cMTypesApi = createApi({
  reducerPath: 'cMTypesApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['Types'],
  endpoints: (builder) => ({
    listCampaignsType: builder.query({
      query: (params) => ({
        url: `/campaigns/types/`,
        params,
      }),
      providesTags: ['Types'],
      
    }),

    createCampaignsType: builder.mutation({
      query: (data) => ({
        url: `/campaigns/types`,
        method: 'POST',
        body: data,
      }),
      providesTags: ['Types'],
    }),

    updateCampaignsType: builder.mutation({
      query: ({ id, data }) => ({
        url: `/campaigns/types/${id}/`,
        method: 'PATCH',
        body: data,
      }),
      providesTags: ['Types'],
    }),

    
  }),
});

export const {
  useListCampaignsTypeQuery,
  useCreateCampaignsTypeMutation,
  useUpdateCampaignsTypeMutation,
} = cMTypesApi;
